export * from './IconWellOrange';
